import { Pipe, PipeTransform } from '@angular/core';
import * as countryDataFromJson from '../../assets/data/country_iso_code.json';

@Pipe({
    name: 'country',
    standalone: true
})
export class CountryPipe implements PipeTransform {

  countries: any = (countryDataFromJson as any).default;

  transform(value: string | undefined): string | null {


    if (value === undefined || value === null) {
      return null;
    }

    for (let i = 0; i < this.countries.length; i++) {
      if (this.countries[i].countryCode === value) {
        return this.countries[i].country;
      }
    }
    return null;
  }

}
